import { FC } from "react";
import { ConfigurationListItem, ConfigurationListItemKind } from "./configuration.types";
import { Divider, ListContainer } from "./configuration.styles";
import { ConfigurationListPermissionRow } from "./rows/configuration-list-permission-row";
import { ConfigurationListToggleRow } from "./rows/configuration-list-toggle-row";
import { ConfigurationListButtonRow } from "@/components/configuration/rows/configuration-list-button-row";

interface Props {
  items: ConfigurationListItem[];
}

export const ConfigurationList: FC<Props> = ({ items }) => {
  return (
    <ListContainer>
      {items.map(item => {
        switch (item.kind) {
          case ConfigurationListItemKind.Divider:
            return <Divider key={item.id} />;
          case ConfigurationListItemKind.Permission:
            return <ConfigurationListPermissionRow key={item.id} {...item} />;
          case ConfigurationListItemKind.Toggle:
            return <ConfigurationListToggleRow key={item.id} {...item} />;
          case ConfigurationListItemKind.Button:
            return <ConfigurationListButtonRow key={item.id} {...item} />;
          default:
            return null;
        }
      })}
    </ListContainer>
  );
};
